import api from "./api";

const CompanyService = {

  getAllCompany: async () => {
    const res = await api.get("company/get");
    return res.data;
  },

  save: async (data) => {
    const res = await api.post("/company/save", data);
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/company/getById/${id}`);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/company/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/company/${id}`);
    return res.data;
  },

  updateStatus: async (id, status) => {
    const res = await api.put(`/company/updateStatus/${id}`, { newStatus: status });
    return res.data;
  },

  getActiveCompanies: async () => {
    const res = await api.get("/company/activeCompanies");
    return res.data;
  },


}

export default CompanyService;
